__turbopack_context__.v({
  "section": "TypesSection-module-scss-module__rDmj-a__section",
  "sectionTitle": "TypesSection-module-scss-module__rDmj-a__sectionTitle",
  "typeLabel": "TypesSection-module-scss-module__rDmj-a__typeLabel",
  "typeList": "TypesSection-module-scss-module__rDmj-a__typeList",
  "typeOption": "TypesSection-module-scss-module__rDmj-a__typeOption",
  "typeWarning": "TypesSection-module-scss-module__rDmj-a__typeWarning",
});
